import { featureToggle } from "@faire/web--source/common/settings/declarations/featureToggle";

/**
 * Setting to control whether the browser tab ID header is added to outgoing requests.
 */
export const FE_ADD_BROWSER_TAB_ID_HEADER_240402 = featureToggle({
  name: "FE_ADD_BROWSER_TAB_ID_HEADER_240402",
  defaultValue: false,
  identifier: "SessionToken",
  client: "RETAILER",
  productArea: "INFRA",
  notifyAfter: "2026-07-01",
});
